import BaseProxy from './Proxy.js'
import { SettingsCourseView } from './types/settings'

class SettingsProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/v23/user/settings', parameters)
  }

  migrate() {
    return this.submit('put', this.endpoint, {
      coursesView: SettingsCourseView.Roadmap
    })
  }
}

export default SettingsProxy
